module.exports = __webpack_public_path__ + "static/media/llanta-layout.f5163242.svg";